module.exports = __webpack_public_path__ + "img/local-20.c8e96ee1.jpg";